import { useState } from 'react'
import { ToastContainer } from 'react-toastify'

import Navigation   from './components/Navigation/index'
import ReleaseNotes from './components/ReleaseNotes/index'
import Login from './components/Login'

import 'react-toastify/dist/ReactToastify.css'
import GlobalStyle  from './styles/global'
import { Label } from 'semantic-ui-react'
import { 
    Container, 
    Content, 
    Title, 
    HeaderContent, 
    HeaderLabelsContainer, 
    MainContainer
} from './styles'
import Logout from './components/Logout'


function App() {
    const [modalShow, setModalShow] = useState(false)
    const token = localStorage.getItem('token')

    const appVersion = 'v2.12.3'
    const features = [
        'Acionamento das procedures de BI Engine e Sinistralidade adicionados.',
        'Adiciona botão de sair',
    ]
    const improvements = [
        'Impedimento no acionamento do botão de enviar antes do processamento finalizar.',
    ]
    const bugsFixes = []

    if(!localStorage.getItem('showReleaseNotes')){
        setModalShow(true)
        localStorage.setItem('showReleaseNotes', false)
    }


    return (
        <MainContainer>
            <GlobalStyle />
            <ReleaseNotes 
                show={modalShow}
                onHide={() => setModalShow(false)}
                appVersion={appVersion}
                improvements={improvements}
                features={features}
                bugsFixes={bugsFixes}
            />
            <ToastContainer theme="colored"/>
            <Container>
                <Content>
                    <HeaderContent>
                        <HeaderLabelsContainer>
                            <Label as='a' onClick={() => setModalShow(true)}>{appVersion}</Label>
                            <Logout />
                        </HeaderLabelsContainer>
                        <Title>Suripoint</Title>
                    </HeaderContent>
                    {!token ? <Login /> : <Navigation />}
                </Content>
            </Container>
        </MainContainer>
    )
}

export default App
